import { useEffect, useRef, useState } from "react";
import { motion, useInView } from "framer-motion";

export const AnimatedCounter = ({ value, suffix = "", label }) => {
  const [count, setCount] = useState(0);
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "-100px" });

  useEffect(() => {
    if (!isInView) return;

    const duration = 2000;
    const steps = 60;
    const increment = value / steps;
    let current = 0;
    const timer = setInterval(() => {
      current += increment;
      if (current >= value) {
        setCount(value);
        clearInterval(timer);
      } else {
        setCount(Math.floor(current * 10) / 10);
      }
    }, duration / steps);

    return () => clearInterval(timer);
  }, [isInView, value]);

  const displayValue = Number.isInteger(value) ? Math.floor(count) : count.toFixed(1);

  return (
    <motion.div
      ref={ref}
      initial={{ opacity: 0, scale: 0.8 }}
      whileInView={{ opacity: 1, scale: 1 }}
      viewport={{ once: true }}
      transition={{ duration: 0.5 }}
      className="text-center group"
      data-testid={`counter-${label.toLowerCase().replace(/\s+/g, "-")}`}
    >
      <div className="relative">
        <span className="font-outfit font-bold text-4xl sm:text-5xl lg:text-6xl text-white tabular-nums">
          {displayValue}
        </span>
        <span className="font-outfit font-bold text-3xl sm:text-4xl lg:text-5xl text-blue-400">
          {suffix}
        </span>
        <div className="absolute -inset-4 bg-blue-500/5 blur-2xl rounded-full opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
      </div>
      <p className="mt-2 text-slate-400 text-sm font-medium tracking-wide uppercase">
        {label}
      </p>
    </motion.div>
  );
};
